import { getLanguageFromLocalStorage } from "utils";

import {
  CAREER_LINK_CZ,
  CAREER_LINK_DE,
  CAREER_LINK_DEFAULT,
  CAREER_LINK_GB,
  CAREER_LINK_PL,
  CONTACT_LINK_CZ,
  CONTACT_LINK_DE,
  CONTACT_LINK_DEFAULT,
  CONTACT_LINK_GB,
  CONTACT_LINK_PL,
  LANGUAGE_CODE,
  WEBINAR_LINK_DE,
  WEBINAR_LINK_DEFAULT,
  WEBINAR_LINK_GB,
  WEBINAR_LINK_PL,
} from "consts";

export const getContactLink = () => {
  const locale = getLanguageFromLocalStorage();
  if (locale === LANGUAGE_CODE.GERMAN) {
    return CONTACT_LINK_DE;
  }

  if (locale === LANGUAGE_CODE.ENGLISH_GB) {
    return CONTACT_LINK_GB;
  }

  if (locale === LANGUAGE_CODE.POLISH) {
    return CONTACT_LINK_PL;
  }

  if (locale === LANGUAGE_CODE.CZECH) {
    return CONTACT_LINK_CZ;
  }

  return CONTACT_LINK_DEFAULT;
};

export const getWebinarLink = () => {
  const locale = getLanguageFromLocalStorage();

  if (locale === LANGUAGE_CODE.GERMAN) {
    return WEBINAR_LINK_DE;
  }

  if (locale === LANGUAGE_CODE.ENGLISH_GB) {
    return WEBINAR_LINK_GB;
  }

  if (locale === LANGUAGE_CODE.POLISH) {
    return WEBINAR_LINK_PL;
  }

  return WEBINAR_LINK_DEFAULT;
};

export const getCareerLink = () => {
  const locale = getLanguageFromLocalStorage();

  if (locale === LANGUAGE_CODE.GERMAN) {
    return CAREER_LINK_DE;
  }

  if (locale === LANGUAGE_CODE.ENGLISH_GB) {
    return CAREER_LINK_GB;
  }

  if (locale === LANGUAGE_CODE.POLISH) {
    return CAREER_LINK_PL;
  }

  if (locale === LANGUAGE_CODE.CZECH) {
    return CAREER_LINK_CZ;
  }

  return CAREER_LINK_DEFAULT;
};
